import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Dashboard from "../../layout/Dashboard/Dashboard";
import { Button, Container, Row, Col, Card, Spinner } from "react-bootstrap";
import { useCharts } from "../../hooks/useCharts";
import { usePivot } from "../../hooks/usePivot";
import "./SingleDaahboard.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import CookieManager from "../../components/Cookies/CookieManager";
import { useTranslation } from "react-i18next";
import "../../i18n";

const SingleDashboard = () => {
  const [charts, setCharts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { getAvailableCharts, deleteAChart, getOneChart } = useCharts();
  const { deletTable } = usePivot();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCharts = async () => {
      try {
        const dashboardCharts = await getAvailableCharts();
        const chartImages = dashboardCharts.map((chart) => ({
          id: chart.id,
          name: chart.name,
          imageBase64: chart.imageBase64,
        }));
        setCharts(chartImages);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching charts:", error);
        setIsLoading(false);
      }
    };

    fetchCharts();
  }, []);

  const handleDeleteChart = async (chartId, tableId) => {
    try {
      const chart = await getOneChart(chartId);
      const tableId = chart.pivotId;
      await deleteAChart(chartId);
      await deletTable(tableId);
      setCharts((prevCharts) =>
        prevCharts.filter((chart) => chart.id !== chartId)
      );
    } catch (error) {
      console.error("Error deleting chart:", error);
    }
  };

  return (
    <Dashboard>
      <CookieManager />

      {isLoading ? (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : (
        <>
          {/* Back Button */}
          <div className="button-container-single">
            <Button
              className="custom-btn  fw-bold "
              onClick={() => navigate("/create-chart")}
            >
              {t("backToCreateChart")}
            </Button>
          </div>

          <Row className="gx-4 gy-4">
            {charts.map((chart, index) => {
              const colSize =
                charts.length === 1
                  ? { xs: 12, md: 8, lg: 6 }
                  : charts.length <= 3
                  ? { xs: 12, md: 6, lg: 4 } // 2-3 charts: Medium cards
                  : { xs: 12, md: 6, lg: 3 }; // 4+ charts: Smaller cards

              return (
                <Col key={chart.id} {...colSize}>
                  <Card className="card-single">
                    <Card.Header
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <strong>{chart.name}</strong>
                      <div style={{ marginLeft: "auto" }}>
                        {/* Edit Chart */}
                        <a
                          style={{
                            textDecoration: "none",
                            color: "green",
                            marginRight: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(`/edit-chart?chartid=${chart.id}`)
                          }
                        >
                          {t("edit")}
                        </a>
                        {/* Delete Chart */}
                        <a
                          style={{
                            textDecoration: "none",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteChart(chart.id)}
                        >
                          {t("delete")}
                        </a>
                      </div>
                    </Card.Header>
                    <Card.Body className="d-flex justify-content-center">
                      {chart.imageBase64 ? (
                        <img
                          src={chart.imageBase64}
                          alt="Saved Chart"
                          className="img-fluid"
                        />
                      ) : (
                        <p> {t("noImageAvailable")} </p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </Dashboard>
  );
};

export default SingleDashboard;
